@if (population) {
<app-notes [population]="population"></app-notes>
}
